import React from 'react';
import BASKET_UPDATE_TYPES from '@routes/Basket/components/BasketUpdateTypes';
import { BasketItem } from '@common/components/BasketItem';
import { Routes } from '@common/constants';
import { Price, Discount } from 'shared-types/Common';

import { ProductMetadata } from './ProductMetadata';
import { Product as ProductType } from 'shared-types/Product';

export type ProductProps = {
  onChange: (
    type: BASKET_UPDATE_TYPES.QUANTITY | BASKET_UPDATE_TYPES.REMOVE,
    itemId: number | string,
    quantity?: number
  ) => void;
  item: {
    linkRoute: string;
    /**
     * @deprecated Migrating to fulfilables service typings, post-MVP
     */
    product: ProductType;
    /**
     * @deprecated Migrating to fulfilables service typings
     */
    option: any;
    id: number;
    quantity: number;
    price: Price;
    discount?: Discount;
  };
  isEditable: boolean;
  isQuantityPickerHidden?: boolean;
};

export const Product: React.FC<ProductProps> = ({
  onChange,
  isQuantityPickerHidden,
  item: { linkRoute = Routes.PRODUCT_DETAIL, product, option, id, quantity, price, discount },
  isEditable = true,
}) => {
  const linkParams = {
    id: product.id,
  };
  const name = `${product.name} ${option ? `- ${option.name}` : ''}`;
  const imageUrl =
    product.imageGallery && product.imageGallery.length > 0 ? product.imageGallery[0].url : null;

  function handleProductRemoval() {
    onChange(BASKET_UPDATE_TYPES.REMOVE, id);
  }

  function renderMetadata() {
    return (
      <ProductMetadata
        isQuantityPickerHidden={isQuantityPickerHidden}
        quantity={quantity}
        option={option}
        onQuantityChange={(quantity) => onChange(BASKET_UPDATE_TYPES.QUANTITY, id, quantity)}
        isEditable={isEditable}
      />
    );
  }

  return (
    <BasketItem
      isEditable={isEditable}
      key={id}
      linkParams={linkParams}
      linkRoute={linkRoute}
      name={name}
      onRemove={handleProductRemoval}
      price={discount?.standardPrice || price}
      discount={discount}
      renderMetadata={renderMetadata}
      thumbnail={imageUrl}
    />
  );
};
